// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Select from "@insite/mobius/Select";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { SelectPresentationProps } from "@store/MobiusOverrides/Select/Select";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/UpdateDraftParameter";
import { useOrderHistoryState } from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { findDisplayName } from "@store/Overrides/Widgets/OrderHistory/OrderHistorySearchFieldStatus";
import React, { FC, useMemo } from "react";

export interface OrderHistoryFilterFieldStatusStyles {
    searchStatusField?: SelectPresentationProps;
}

export const OrderHistoryFilterFieldStatusStyles: OrderHistoryFilterFieldStatusStyles = {};

const styles = OrderHistoryFilterFieldStatusStyles;

const OrderHistoryFilterFieldStatus: FC = () => {
    const { status } = useOrderHistoryState().draftParameter;
    const id = useMemo(uniqueId, []);
    const dispatch = useAppDispatch();
    const orderStatusMappings = useAppSelector(state => getOrderStatusMappingDataView(state).value);

    const options = orderStatusMappings || [];
    const uniqueOptions = new Map<string, string[]>();
    for (const option of options) {
        const erpOrderStatuses = uniqueOptions.get(option.displayName) || [];
        erpOrderStatuses.push(option.erpOrderStatus);
        uniqueOptions.set(option.displayName, erpOrderStatuses);
    }
    const value = status && status.length > 0 ? status.join(",") : "";

    const handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
        if (event.currentTarget.value) {
            dispatch(
                updateDraftParameter({
                    status: event.currentTarget.value.split(","),
                    displayName: findDisplayName(event.currentTarget.value, orderStatusMappings),
                }),
            );
        } else {
            dispatch(updateDraftParameter({ status: undefined }));
        }
    };

    return (
        <FilterDrawerSection
            title={translate("Order Status")}
            modalTitle={translate("Order Status Descriptions")}
            labelFor={id}
            modalText={siteMessage("OrderHistory_OrderStatusDescriptions")}
        >
            <Select
                {...styles.searchStatusField}
                value={value}
                onChange={handleChange}
                data-test-selector="orderHistory_filterStatus"
                id={id}
            >
                <option value="">{translate("Select")}</option>
                {Array.from(uniqueOptions, ([name, values]) => ({ name, values })).map(option => (
                    <option key={option.values.join(",")} value={option.values.join(",")}>
                        {option.name}
                    </option>
                ))}
            </Select>
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldStatus;
